<template>
  <div>
    <b-modal :id="`bv-modal-edit-contact-`+page" hide-footer>
      <template #modal-title>Edit contact</template>

      <div class="py-3 text-center"><b>{{contact.name}}</b></div>

      <div class="row">
        <div class="col">
            <label class="form-label pt-2 mb-2">Status</label>
            <select class="form-control2" v-model="contact.status">
                <option v-for="(status, index) in statuses" :key="index" :value="status">{{status}}</option>
            </select>
        </div>
      </div>

      <div class="row">
        <div class="col">
            <label class="form-label pt-2 mb-2">Notes</label>
            <textarea class="form-control shadow-none inputbox" rows="3" v-model="contact.notes"></textarea>
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
                  <div>
<button v-if="updating" type="button" class="btn btn-danger submit col">
  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
        <button v-else type="button" class="btn btn-danger submit col" @click="saveEmail">Save</button>
      </div>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
import { EventBus } from '../bus';

export default {
  props: ['contact', 'page'],

  data() {
    return {
      updating: false,
      statuses: ['Waiting', 'Contacted', 'Replied', 'Registered', 'Unsubscribed', 'Failed'],
    };
  },

  methods: {

    hideModalEditContact() {
      this.$bvModal.hide('bv-modal-edit-contact-'+this.page);
    },

            saveEmail() {

              this.updating = true;

              axios.post('/contacts/update', {contact: this.contact})
            .then((response) => {

                this.hideModalEditContact();
                EventBus.$emit('get-contacts');

            }).catch((error) => {

                  this.sweetfire(error.response.data.message);

            }).finally(() => {

              this.updating = false;

            });


      },

  },
};
</script>

<style scoped>
textarea.form-control2 { font-size: 0.9rem !important; }
</style>